<template>
  <div
    v-if="
      (jwtAccessValid() && userProfile.checked && (isWholesaler || isDriver)) || isAdmin || isManager
    "
    class="px-3"
  >
    <div class="sticky">
      <h1 class="text-center">
        АКТЫ ПЕРЕМЕЩЕНИЯ
      </h1>
      <div class="row">
        <div v-if="isAdmin" class="col-1">
          <router-link
            v-if="!isManager"
            class="btn btn-lg btn-primary text-center berry"
            type="button"
            tag="button"
            :to="{ name: 'shipment', params: { id: 'new' }}"
          >
            ДОБАВИТЬ
          </router-link>
        </div>

        <div class="col-1">
          <button
            class="btn btn-lg btn-success text-center berry"
            type="button"
            @click="exportToExcel()"
          >
            EXCEL
          </button>
        </div>

        <div class="col-3">
          <Multiselect
            v-model="currentMaster"
            :options="usersWholesaler"
            :loading="false"
            :internal-search="false"
            valueProp="_id"
            trackBy="fullname"
            label="fullname"
            :filterResults="true"
            :minChars="2"
            :resolveOnLoad="true"
            :searchable="true"
            class="deliverer"
            noOptionsText="Не найден"
            placeholder="Оптовик"
          >
          </Multiselect>
        </div>

        <div class="col-2">
          <Multiselect
            v-model="currentBerry"
            :options="berries"
            :loading="false"
            :internal-search="false"
            valueProp="_id"
            trackBy="label"
            label="label"
            :filterResults="true"
            :minChars="2"
            :resolveOnLoad="true"
            :searchable="true"
            class="deliverer"
            noOptionsText="Не найден"
            placeholder="Ягода"
          >
          </Multiselect>
        </div>

        <div class="col-2">
          <input class="form-control" placeholder="Поиск" v-model="searchText" type="text" />
        </div>
      </div>
    </div>
    <div class="tableFixHead">
      <table
        class="table"
        id="report"
        data-cols-width="18,11,30,14,10,17,10,20,9,14,10,13,14,13,17,19"
      >
        <thead>
          <th>Дата</th>
          <th>Номер</th>
          <th>Оптовик</th>
          <th>Приемщик</th>

          <th>Ягода</th>
          <th>Вес, кг</th>

          <th>Доставлено</th>

          <th>Комментарий</th>

          <th></th>
        </thead>

        <thead v-if="false">
          <th>Дата</th>
          <th>Номер</th>
          <th>Оптовик</th>
          <th>Приемщик</th>

          <th>Ягода</th>
          <th>Вес, кг</th>

          <th>Доставлено</th>

          <th>Комментарий</th>
          <th></th>
        </thead>

        <tbody>
          <tr v-show="exportingToExcel">
            <th>Дата</th>
            <th>Номер</th>
            <th>Оптовик</th>
            <th>Приемщик</th>

            <th>Ягода</th>
            <th>Вес, кг</th>

            <th>Доставлено</th>

            <th>Комментарий</th>

            <td></td>
          </tr>
          <tr
            v-for="doc in docsFilter"
            :key="doc._id"
            :class="{ canceled: doc.cancel }"
            @click="router.push({ name: 'shipment', params: { id: doc._id } })"
          >
            <td>{{ new Date(doc.date).toLocaleString() }}</td>
            <td>{{ `${doc.prefix}-${doc.number}` }}</td>
            <td>
              {{ doc.company.receiver.masterFullname }}
            </td>
            <td>
              {{ doc.company.receiver.fullname }}
            </td>
                       

            <td>
              <span v-if="doc.tableUnit[0].berry">{{ doc.tableUnit[0].berry.label }}</span>
            </td>
            <td data-t="n" data-label="Вес, кг">
              {{ doc.tableUnit[0].weight.toFixed(2) }}
            </td>

            
            <td><font-awesome-icon v-if="doc.closed" icon="check" /></td>
           
            <td>
              <span>{{ doc.comment }}</span>
            </td>
            <td>
              <span v-if="doc.cancel">ОТМЕНЕН</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
import { ref, computed, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import useCommonMixin from "@/components/commonMixin.js";
import Multiselect from "@vueform/multiselect";
import TableToExcel from "@linways/table-to-excel";

export default {
  name: "ShipmentsTable",
  components: { Multiselect },
  props: { writeOff: { type: Boolean, default: false } },
  setup(props) {
    useCommonMixin();
    const {
      jwtAccessValid,
      asyncForEach,
      isReciever,
      userProfile,
      isAdmin,
      isManager,
      isDriver,
      isWholesaler,
    } = useCommonMixin();
    const store = useStore();
    const router = useRouter();
    const docs = ref([]);
    const profiles = ref([{}]);

    const users = ref([]);
    const roles = ref([]);
    const currentMaster = ref();
    const searchText = ref("");
    const exportingToExcel = ref(false);
    const currentBerry = ref("");

    const init = async () => {
      let response = await store.dispatch("FETCHshipment");
      docs.value = response.status ? response.data : [];

      response = await store.dispatch("FETCHuser", "receiver");
      users.value = response.status ? response.data : [];
      asyncForEach(users.value, async user => {
        user.phone = user.phone ? user.phone.slice(2, 12) : "";
        user.fullname = user.receiver.fullname;
      });

      let responseRoles = await store.dispatch("FETCHroles");
      roles.value = responseRoles.status
        ? responseRoles.data.filter(role => role.type != "deliverer")
        : [];

      store.dispatch("FETCHberry");
    };

    const usersWholesaler = computed(() => {
      let wholesalerRole = roles.value.find(item => item.name == "wholesaler");
      let receiverRole = roles.value.find(item => item.name == "receiver");

      let result = [];
      if (wholesalerRole && receiverRole) {
        result = users.value.filter(
          item => item.role == wholesalerRole._id || item.role == receiverRole._id
        );
      }
      return result;
    });

    const docsFilter = computed(() => {
      let result = docs.value;

      if (currentMaster.value) {
        result = result.filter(doc => {
          return doc.company ? doc.company._id == currentMaster.value : false;
        });
      }
      if (searchText.value.length >= 3) {
        result = result.filter(
          doc =>
            JSON.stringify(doc)
              .toLowerCase()
              .indexOf(searchText.value.toLowerCase()) >= 0
        );
      }

      if (currentBerry.value) {
        result = result.filter(doc => doc.tableUnit[0].berry._id == currentBerry.value);
      }

      return result;
    });

    const exportToExcel = () => {
      exportingToExcel.value = true;
      let table = document.getElementById("report");
      TableToExcel.convert(table);
      exportingToExcel.value = false;
    };

    const acceptTotal = doc => {
      let result = 0;
      if (doc.cancel) {
        return result;
      }

      if (doc.detailsTotal) {
        result += doc.detailsTotal.weightDry + doc.detailsTotal.weightShrink;
      } else {
        result += doc.tableUnit[0].weight;
      }
      return result;
    };


    const totalInit = {
      accept: 0,
      transfer: 0,
      weightManual: 0,
      shrink: 0,
      totalToPay: 0,
      acceptPrice: 0,
      transferPrice: 0,
      priceManual: 0,
      priceBonus: 0,
      priceCompanyBonus: 0,
      priceReceiverBonus: 0,
      priceShrink: 0,
      priceLogist: 0,
      priceCost: 0,
      revenueSum: 0,
      bonusReceiverSum: 0,
      bonusMasterSum: 0,
      revenue: 0
    };
    const total = ref(totalInit);
    const calcTotal = () => {
      total.value = JSON.parse(JSON.stringify(totalInit));

      docsFilter.value.forEach(doc => {
        if (!doc.cancel) {
        }
      });

    };

    watch(
      () => docsFilter.value,
      () => {
        console.log("watch docsFilter");
        calcTotal();
      }
    );

    const berries = computed(() => {
      let berry;
      berry = store.getters.berry;
      return berry;
    });

    onMounted(init);

    return {
      jwtAccessValid,
      isReciever,
      docs,
      profiles,
      router,
      userProfile,
      isAdmin,
      isManager,
      docsFilter,
      usersWholesaler,
      searchText,
      currentMaster,
      exportToExcel,
      exportingToExcel,
      acceptTotal,
      total,
      berries,
      currentBerry,
      isDriver,
      isWholesaler,
    };
  }
};
</script>

<style>
.canceled {
  background-color: #e44d4d6b !important;
}
.tableFixHead {
  overflow: auto;
  height: calc(100vh - 210px);
}
.tableFixHead thead th {
  position: sticky;
  top: 0;
  z-index: 1;
}

.tableFixHead table {
  border-collapse: collapse;
  width: 100%;
}
.tableFixHead th,
td {
  padding: 8px 16px;
}
.tableFixHead th {
  background: #eee;
}
</style>
